import React, { useState, useEffect, useRef } from "react";
import apiService from "../../config";
import { useLanguage } from '../../StoreContext/LanguageContext';

const ViewRailwayProposal = ({ proposalId, projectId, projectName, onBack }) => {

    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [documentUrl, setDocumentUrl] = useState('');
    const { language, translations } = useLanguage();
    // View
    const [viewingProposal, setViewingProposal] = useState(null);
    const documentRef = useRef(null);

    // State to manage image modal
    const [imageModalUrl, setImageModalUrl] = useState(null);
    const { thumbnailUrl, fullImageUrl } = viewingProposal || {};

    const isImageUrl = (url) => {
        if (!url) return false;
        const ext = url.split('.').pop().toLowerCase();
        return ["jpg", "jpeg", "png", "gif", "webp", "bmp"].includes(ext);
    };

    const openImageModal = (url) => {
        setImageModalUrl(url);
    };

    const closeImageModal = () => {
        setImageModalUrl(null);
    };

    <img
        src={thumbnailUrl}
        alt="Document Thumbnail"
        className="cursor-pointer"
        onClick={() => openImageModal(fullImageUrl)}
    />

    const handleDownload = () => {
      const printContent = documentRef.current?.innerHTML;
      if (!printContent) {
        alert("No content available to print.");
        return;
      }

      const win = window.open("", "", "height=900,width=1200");
      win.document.write(`
      <html>
      <head>
        <title>जिगांव प्रकल्प अहवाल</title>
        <style>
          @page {
            size: A4 portrait;
            margin-top: 0.19in;
            margin-bottom: 0.25in;
            margin-left: 0.81in;
            margin-right: 0.5in;
          }
          body {
            font-family: 'DVOT-Surekh', 'Mangal', 'Arial', sans-serif;
            -webkit-print-color-adjust: exact;
            color-adjust: exact;
            background: white;
          }

          h2 {
            font-size: 18px;
            text-align: center;
            margin-bottom: 12px;
            font-weight: bold;
          }

          .text-center { text-align: center; }
          .text-right { text-align: right; }
          .font-bold { font-weight: bold; }
          .mb-4 { margin-bottom: 1rem; }
          .my-4 { margin: 1rem 0; }
          .mt-6 { margin-top: 1.5rem; }

          table {
            width: 100%;
            border-collapse: collapse;
            font-size: 13px;
            page-break-inside: auto;
          }
          th, td {
            border: 1px solid #000;
            padding: 6px 8px;
          }
          th {
            background-color: #e5e7eb !important; /* gray-200 */
            font-weight: bold;
          }
          

          /* Hide buttons or unnecessary UI in print */
          button, .no-print { display: none !important; }

          /* Ensure long tables split nicely */
          thead { display: table-header-group; }
          tfoot { display: table-footer-group; }

          /* Optional spacing & borders similar to Section15 */
          .document-container {
            max-width: 100%;
            margin: 0 auto;
          }

        </style>
      </head>
      <body>
        <div class="document-container">
          ${printContent}
        </div>
      </body>
    </html>
  `);

      win.document.close();
      win.print();
    };

    // Handle document view
    const handleViewDocument = (fileOrUrl) => {
        console.log("🔎 handleViewDocument called with:", fileOrUrl);

        if (!fileOrUrl) {
            console.warn("⚠️ No fileOrUrl passed, nothing to show.");
            return;
        }

        if (fileOrUrl instanceof File) {
            console.log("📂 Detected a File object:", fileOrUrl.name);
            const url = URL.createObjectURL(fileOrUrl);
            console.log("👉 Created blob URL:", url);
            setDocumentUrl(url);
        } else {
            console.log("🌐 Detected a string URL:", fileOrUrl);
            setDocumentUrl(fileOrUrl);
        }

        setShowModal(true);
        console.log("✅ Modal state set to true");
    };

    useEffect(() => {
        const handleViewClick = async () => {
            if (!projectId || !proposalId) {
                alert("No project selected");
                return;
            }

            console.log("Fetching proposal details for projectId:", projectId, "and proposalId:", proposalId);

            setLoading(true);
            try {
                const result = await apiService.getRailwayProposalById(projectId, proposalId);
                if (result && result.status === 200) {
                    const proposalsData = Array.isArray(result.data) ? result.data[0] : result.data;
                    console.log("Fetched proposal data:", proposalsData);
                    setViewingProposal(proposalsData);
                } else {
                    setViewingProposal(null);
                }
            } catch (error) {
                setViewingProposal(null);
            } finally {
                setLoading(false);
            }
        };

        handleViewClick();
    }, [projectId, proposalId]); // runs whenever IDs change

    if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '200px',
        fontSize: '16px'
      }}>
        प्रस्ताव माहिती लोड करत आहे...
      </div>
    );
  }

    return (
        <>
            {viewingProposal && (
                <div ref={documentRef} className="max-w-4xl mx-auto">
                    {/* Print Button - Hidden during print */}
                    <div className="mb-4 print:hidden">
                        <button
                            onClick={handleDownload}
                            className="bg-green-500 text-white px-6 py-2 rounded hover:bg-green-600"
                        >
                            Print
                        </button>
                    </div>
                    <div className=" font-sans pt-4">

                        {/* Header */}
                        <p className="text-center font-semibold mb-2">
                            प्रकल्पाच्या आखणीमध्ये समाविष्ट जमिनींचा तपशील
                        </p>
                        <h3 className="text-center font-semibold mb-2">
                            प्रकल्प नाव: {projectName || 'N/A'} | प्रस्ताव नाव/नाव: {viewingProposal.acquisition_proposal_no}
                        </h3>
                        <p className="text-center font-semibold mb-2">
                            मौजे : {viewingProposal.village_name} , तालुका : {viewingProposal.taluka_name} ,  जिल्हा : {viewingProposal.dist_name}
                        </p>
                        <div className="text-center mb-5">
                            <h2 className="mb-4 text-2xl font-bold">
                                नमुना "क"
                            </h2>
                            <p class="text-sm m-0 leading-tight mb-5 text-center font-semibold">
                                {projectName || 'N/A'} साठी खाजगी जमिनीच्या भूसंपादचा प्रस्ताव {viewingProposal.acquisition_proposal_no}
                            </p>
                        </div>
                        <table className="w-full border-collapse border-2 border-black text-base">
                            <tbody>
                                {/* १ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">
                                        १
                                    </td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        प्रस्ताव पाठविणाऱ्या अधिकाऱ्याचे पदनाम व पत्ता
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex flex-col gap-2">
                                            <div>
                                                <span className="font-semibold">नाव: </span>
                                                <span className="break-words">{viewingProposal.acquisition_incharge_name || "N/A"}</span>
                                            </div>
                                            <div>
                                                <span className="font-semibold">पदनाम/संपादन संस्थेचे नाव: </span>
                                                <span className="break-words">{viewingProposal.acquisition_incharge_designation || "-"}</span>
                                            </div>
                                            <div>
                                                <span className="font-semibold">पत्ता: </span>
                                                <span className="break-words">{viewingProposal.acquisition_incharge_address || "-"}</span>
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                                {/* २ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">२</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        संपादन संस्थेचे नाव व पत्ता                                    </td>
                                    <td className="border border-black px-4 py-3 break-words">
                                        {viewingProposal.acquisition_agency || "-"}
                                    </td>
                                </tr>

                                {/* ३ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">३</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        मंत्रालयीन स्तरावरील संबंधित प्रशासकीय विभाग
                                    </td>
                                    <td className="border border-black px-4 py-3 break-words">
                                        {viewingProposal.acquisition_department || "-"}
                                    </td>
                                </tr>

                                {/* ४ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">४</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        जमीन कोणत्या प्रयोजनासाठी संपादन करून हवी आहे
                                    </td>
                                    <td className="border border-black px-4 py-3 break-words">
                                        {viewingProposal.acquisition_purpose || "-"}
                                    </td>
                                </tr>

                                {/* ५ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">५</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        जमीन संपादन कोणत्या कायदयाखाली करून हवी आहे
                                    </td>
                                    <td className="border border-black px-4 py-3 break-words">
                                        {viewingProposal.acquisition_government_policy || "-"}
                                    </td>
                                </tr>

                                {/* ६ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">६</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        संपादन क्षेत्रात मोडणारी गावे, तालुका व जिल्हा कोणता?
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex flex-col gap-2">
                                            <div>
                                                <span className="font-semibold">जिल्हा: </span>
                                                <span className="break-words">{viewingProposal.dist_name || "-"}</span>
                                            </div>
                                            <div>
                                                <span className="font-semibold">तालुका: </span>
                                                <span className="break-words">{viewingProposal.taluka_name || "-"}</span>
                                            </div>
                                            <div>
                                                <span className="font-semibold">गाव: </span>
                                                <span className="break-words">{viewingProposal.village_name || "-"}</span>
                                            </div>
                                        </div>
                                    </td>

                                </tr>

                                {/* ७ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">७</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        संपादन करून हवे असलेले एकूण क्षेत्र
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex flex-col gap-2">
                                            <div>
                                                <span className="font-semibold">एकूण क्षेत्र: </span>
                                                <span className="break-words">{viewingProposal.total_area || "-"}({viewingProposal.area_unit || "-"})</span>
                                            </div>
                                            <div>
                                                <span className="font-semibold">संपादन क्षेत्र: </span>
                                                <span className="break-words">{viewingProposal.aquired_area || "-"}({viewingProposal.area_unit || "-"})</span>
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                                {/* ८ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">८</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        गावनिहाय व सर्व क्रमांकानुसार आणि संपादन क्षेत्राच्या चर्तुःसिमा दाखविणारी या सोबतच्या नमून्यातील अनुसूची यासोबत जोडणे आवश्यक आहे त्याप्रमाणे ती जोडली आहे काय?
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex items-center gap-3">
                                            <span>{viewingProposal.schedule_6_08 ? "होय" : "नाही"}</span>
                                            {viewingProposal.schedule_6_08_file ? (
                                                <button
                                                    onClick={() => handleViewDocument(viewingProposal.schedule_6_08_file)}
                                                    className="bg-blue-500 text-white px-3 py-1 rounded text-xs hover:bg-blue-600"
                                                >
                                                    View
                                                </button>
                                            ) : (
                                                <span className="text-black-500 text-base"></span>
                                            )}
                                        </div>
                                    </td>
                                </tr>

                                {/* ९ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">९</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        संपादन करावयाच्या क्षेत्राचा चित्रांकित साक्षांकित नकाशा यासोबत जोडाणे आवश्यक आहे त्याप्रमाणे तो जोडला आहे काय?
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex items-center gap-3">
                                            <span>{viewingProposal.schedule_4_09 ? "होय" : "नाही"}</span>
                                            {viewingProposal.schedule_4_09_file ? (
                                                <button
                                                    onClick={() => handleViewDocument(viewingProposal.schedule_4_09_file)}
                                                    className="bg-blue-500 text-white px-3 py-1 rounded text-xs hover:bg-blue-600"
                                                >
                                                    View
                                                </button>
                                            ) : (
                                                <span className="text-black-500 text-base"></span>
                                            )}
                                        </div>
                                    </td>
                                </tr>

                                {/* १० अ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">१०</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        संपादन करावयाच्या क्षेत्राचे ७/१२ उतारे किंवा मालमत्ता नोंदवहीतील उतारे यासोबत जोडणे आवश्यक आहे त्याप्रमाणे ते जोडले आहेत काय?
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex items-center gap-3">
                                            <span>{viewingProposal.extracts_7_12_10 ? "होय" : "नाही"}</span>
                                            {viewingProposal.extracts_7_12_10_file ? (
                                                <button
                                                    onClick={() => handleViewDocument(viewingProposal.extracts_7_12_10_file)}
                                                    className="bg-blue-500 text-white px-3 py-1 rounded text-xs hover:bg-blue-600"
                                                >
                                                    View
                                                </button>
                                            ) : (
                                                <span className="text-black-500 text-base"></span>
                                            )}
                                        </div>
                                    </td>
                                </tr>


                                {/* ११ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">११</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                       संपादन क्षेत्राचे सिमांकन करण्यात आले आहे काय ? असल्यास सिमांकन प्रमाणपत्र सोबत जोडले आहे काय? 
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex items-center gap-3">
                                            <span>{viewingProposal.demarcation_11 ? "होय" : "नाही"}</span>
                                            {viewingProposal.demarcation_11_file ? (
                                                <button
                                                    onClick={() => handleViewDocument(viewingProposal.demarcation_11_file)}
                                                    className="bg-blue-500 text-white px-3 py-1 rounded text-xs hover:bg-blue-600"
                                                >
                                                    View
                                                </button>
                                            ) : (
                                                <span className="text-black-500 text-base"></span>
                                            )}
                                        </div>
                                    </td>
                                </tr>

                                {/* १२ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">१२</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                       संपादन करावयाच्या संपूर्ण जमिनीचा वा तिच्या काही भागाचा खाजगीरित्या ताबा घेतला आहे काय? असल्यास, केव्हा व त्याबाबतीत भुसंपादन नियम पुस्तिकेच्या परिच्छेद २१ अन्वये परिशिष्ट २६ प्रमाणे पंचनामा व करार केला आहे काय? असल्यास, त्याची प्रत सोबत जोडावी. 
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex items-center gap-3">
                                            <span>{viewingProposal.acquisition_matter_12 ? "होय" : "नाही"}</span>
                                            {viewingProposal.acquisition_matter_12_file ? (
                                                <button
                                                    onClick={() => handleViewDocument(viewingProposal.acquisition_matter_12_file)}
                                                    className="bg-blue-500 text-white px-3 py-1 rounded text-xs hover:bg-blue-600"
                                                >
                                                    View
                                                </button>
                                            ) : (
                                                <span className="text-black-500 text-base"></span>
                                            )}
                                        </div>
                                    </td>
                                </tr>

                                {/* १३ */}
                                <tr className="border border-black hover:bg-black-50 align-top">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">१३</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        संपादन कायम स्वरूपाचे किंवा तात्पुरते आहे काय?
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <pre className="whitespace-pre-wrap break-words text-sm">{viewingProposal.land_acquisition_type_13 || "-"}</pre>
                                    </td>
                                </tr>

                                {/* १४ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">१४</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        गरजेनुसार आवश्यक तेवढेच क्षेत्र संपादन करून मागितले आहे की जरूरीपेक्षा जास्त क्षेत्राची मागणी केली आहे? असल्यास किती जास्त क्षेत्राची व का? 
                                    </td>
                                   <td className="border border-black px-4 py-3">
                                        <pre className="whitespace-pre-wrap break-words text-sm">{viewingProposal.excess_land_reason_14 || "-"}</pre>
                                    </td>
                                </tr>

                                {/* १५ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">१५</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        संबंधित प्रयोजनासाठी जवळपास कमी खर्चाची वा सरकारी जमिन उपलब्ध नाही काय ? असल्यास संपादन करून मागितलेलीच जमीन का हवी आहे? 
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex items-center gap-3">
                                            <span>{viewingProposal.other_govt_land_15 ? "होय" : "नाही"}</span>
                                            {viewingProposal.other_govt_land_15_file ? (
                                                <button
                                                    onClick={() => handleViewDocument(viewingProposal.other_govt_land_15_file)}
                                                    className="bg-blue-500 text-white px-3 py-1 rounded text-xs hover:bg-blue-600"
                                                >
                                                    View
                                                </button>
                                            ) : (
                                                <span className="text-black-500 text-base"></span>
                                            )}
                                        </div>
                                    </td>
                                </tr>

                                {/* १६ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">१६</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        संपादन क्षेत्रात, धार्मिक प्रार्थना स्थळे वा मंदीरे, कबरस्थान वा स्मशानभूमी किंवा प्राचीन स्मारके येतात काय? किंवा ती संपादन क्षेत्राच्या जवळपास असल्यास किती अंतरावर आहेत ?
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex items-center gap-3">
                                            <span>{viewingProposal.near_religious_places_16 ? "होय" : "नाही"}</span>
                                            {viewingProposal.near_religious_places_16_file ? (
                                                <button
                                                    onClick={() => handleViewDocument(viewingProposal.near_religious_places_16_file)}
                                                    className="bg-blue-500 text-white px-3 py-1 rounded text-xs hover:bg-blue-600"
                                                >
                                                    View
                                                </button>
                                            ) : (
                                                <span className="text-black-500 text-base"></span>
                                            )}
                                        </div>
                                    </td>
                                </tr>

                                {/* १७ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">
                                        १७
                                    </td>

                                    {/* अ. question */}
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        संपादन करावयाच्या क्षेत्रातून कोणताही सार्वजनिक मार्गाधिकारी जलप्रवाह, जलवाहिनी किंवा जल:निसारण मार्ग आहे काय किंवा त्यात काही अडथळा निर्माण होतो काय? 
                                    </td>

                                    {/* Answer column spanning both rows */}
                                    <td className="border border-black px-4 py-3">
                                        {/* अ. answer */}
                                        <div className="flex items-center gap-3 mb-2">
                                            <span>{viewingProposal.public_route_obstruction_17 ? "होय" : "नाही"}</span>
                                            {viewingProposal.public_route_obstruction_17_file ? (
                                                <button
                                                    onClick={() =>
                                                        handleViewDocument(viewingProposal.public_route_obstruction_17_file)
                                                    }
                                                    className="bg-blue-500 text-white px-3 py-1 rounded text-xs hover:bg-blue-600"
                                                >
                                                    View
                                                </button>
                                            ) : (
                                                <span className="text-black-500 text-base"></span>
                                            )}
                                        </div>
                                    </td>
                                </tr>

                                {/* १८ */}
                                {/* any_obstruction_18 any_obstruction_18_file */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">१८</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                       संपादन करून मागितलेलीच जमीन रेल्वे सिमांच्या जवळपास आहे काय? असल्यास किती अंतरावर आहे. 
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex items-center gap-3">
                                            <span>{viewingProposal.near_railway_boundary_18 ? "होय" : "नाही"}</span>
                                            {viewingProposal.near_railway_boundary_18_file ? (
                                                <button
                                                    onClick={() => handleViewDocument(viewingProposal.near_railway_boundary_18_file)}
                                                    className="bg-blue-500 text-white px-3 py-1 rounded text-xs hover:bg-blue-600"
                                                >
                                                    View
                                                </button>
                                            ) : (
                                                <span className="text-black-500 text-base"></span>
                                            )}
                                        </div>
                                    </td>
                                </tr>

                                {/* १९ */}
                                {/* road_obstruction_19  road_obstruction_19_file */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">१९</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        नागरी क्षेत्रात इमारतीमधील खाजगी प्रवेश मार्गाच किंवा हवेचे मार्ग, यावरील कोणत्याही अधिकारात अडथळा येण्याचा संभव आहे काय?
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex items-center gap-3">
                                            <span>{viewingProposal.road_obstruction_19 ? "होय" : "नाही"}</span>
                                            {viewingProposal.road_obstruction_19_file ? (
                                                <button
                                                    onClick={() => handleViewDocument(viewingProposal.road_obstruction_19_file)}
                                                    className="bg-blue-500 text-white px-3 py-1 rounded text-xs hover:bg-blue-600"
                                                >
                                                    View
                                                </button>
                                            ) : (
                                                <span className="text-black-500 text-base"></span>
                                            )}
                                        </div>
                                    </td>
                                </tr>

                                {/* २० */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">२०</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        संपादन क्षेत्राची सीमा व इमारत किंवा कारखाना यांना किंवा यांची जागा छेदून आहे काय?
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex items-center gap-3">
                                            <span>{viewingProposal.private_buildings_20 ? "होय" : "नाही"}</span>
                                            {viewingProposal.private_buildings_20_file ? (
                                                <button
                                                    onClick={() => handleViewDocument(viewingProposal.private_buildings_20_file)}
                                                    className="bg-blue-500 text-white px-3 py-1 rounded text-xs hover:bg-blue-600"
                                                >
                                                    View
                                                </button>
                                            ) : (
                                                <span className="text-black-500 text-base"></span>
                                            )}
                                        </div>
                                    </td>
                                </tr>

                                {/* २१ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">२१</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        भुसंपादनाचा प्रस्ताव कोणत्याही निमशासकीय वा शासकीय वा स्थानिक स्वराज्य संस्थेकडून उदा. महानगरपालिका, महामंडळे इत्यादीकरिता असल्यास असे संपादन करण्याबाबतीत आवश्यक तो ठराव मंजूर झाला आहे काय? असल्यास त्याची प्रत जोडावी.
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <pre className="whitespace-pre-wrap break-words text-sm">{viewingProposal.institutional_resolution_21 || "-"}</pre>
                                    </td>
                                </tr>

                                {/* २२ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">२२</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        जर भुसंपादन मध्येच रद्द करण्यात आल्यास तो पर्यंतच्या काळात भुसंपादनाविषयक झालेला सर्व आस्थापना खर्च नियमानुसार देण्याची संपादन संस्थांची तयारी आहे काय?
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <pre className="whitespace-pre-wrap break-words text-sm">{viewingProposal.cancellation_cost_commitment_22 || "-"}</pre>
                                    </td>
                                </tr>

                                {/* २३ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">२३</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        संपादीत जमिनीची नुकसान भरपाई रक्कम आणि भुसंपादन विषयक सर्व आस्थापना खर्चाची रक्कम यांची आर्थिक तरतूद केलेली आहे काय ?
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <pre className="whitespace-pre-wrap break-words text-sm">{viewingProposal.financial_provision_confirmation_23 || "-"}</pre>
                                    </td>
                                </tr>


                            </tbody>
                        </table>
                        {/* Footer Signatures */}
                        <div className="mt-8">
                        <p className="text-sm">
                        <span className="font-bold text-sm">टिप:- खालील बाबी जोडणे आवश्यक आहे.</span><br />                         
                        1. अनुक्रमांक ८ मध्ये उल्लेखिलेल्याप्रमाणे चित्रांकित अनुसूची.<br/>
                        2. अनुक्रमांक ९ मध्ये उल्लेखिलेल्याप्रमाणे चित्रांकित/ साक्षांकित नकाशा <br/>
                        3. अनुक्रमांक ११ मध्ये उल्लेखिलेल्याप्रमाणे सिमांकन प्रमाणपत्र
                        </p>
                        </div>
                        <div
                        style={{
                            marginTop: "50px",
                            display: "flex",
                            justifyContent: "space-between",
                            fontSize: "12px",
                            alignItems: "flex-start"
                        }}
                        >
                        {/* Left side - Place */}
                        <div style={{ width: "40%" }}>
                            <strong>ठिकाण :</strong> {viewingProposal.village_name || "-"}
                        </div>

                        {/* Right side - Signature block */}
                        <div style={{ width: "55%", textAlign: "right" }}>
                            <div className="text-center" style={{ marginBottom: "25px" }}>
                            संपादन संस्थेच्या जबाबदार अधिकाऱ्याची स्वाक्षरी व शिक्का
                            </div>

                            <div>
                            <p className="text-center">उपकार्यकारी अभियंता, (बांधकाम विभाग),</p>
                            <p className="text-center">दक्षिण मध्य रेल्वे, अकोला</p>
                            </div>
                        </div>
                        </div>


                    </div>
                </div>
            )}

            {/* Image Modal */}
            {imageModalUrl && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-60"
                    onClick={closeImageModal}
                >
                    <div
                        className="relative bg-white rounded-lg shadow-2xl max-w-[95vw] max-h-[95vh] overflow-hidden"
                        onClick={e => e.stopPropagation()}
                    >
                        <button
                            onClick={closeImageModal}
                            className="absolute top-3 right-3 z-10 bg-white bg-opacity-90 hover:bg-opacity-100 text-gray-800 hover:text-red-600 rounded-full w-10 h-10 flex items-center justify-center font-bold text-xl transition-all duration-200 shadow-lg"
                            aria-label="Close image"
                        >
                            ×
                        </button>

                        <div className="p-4">
                            <img
                                src={imageModalUrl}
                                alt="Document View"
                                className="max-w-full max-h-[85vh] object-contain mx-auto block rounded"
                            />
                        </div>
                    </div>
                </div>
            )}

            {/* Document Viewer Modal */}
            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
                    <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl mx-4 max-h-[90vh] overflow-y-auto mt-12">
                        {/* Header */}
                        <div className="flex justify-between items-center p-4">
                            <h3 className="text-xl font-semibold text-gray-800">
                                {translations[language]?.DocumentPreview}
                            </h3>
                            <button
                                onClick={() => {
                                    setShowModal(false);
                                    if (documentUrl?.startsWith("blob:")) {
                                        URL.revokeObjectURL(documentUrl);
                                    }
                                }}
                                className="text-gray-400 hover:text-gray-700 text-2xl font-bold"
                            >
                                ×
                            </button>
                        </div>

                        {/* Document Viewer */}
                        <iframe
                            src={documentUrl}
                            className="w-full h-[80vh] rounded border border-gray-300"
                            title="Document Preview"
                        />
                    </div>
                </div>
            )}

        </>
    );
}
export default ViewRailwayProposal;